import React from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  StatusBar as RNStatusBar,
} from "react-native";
import { Img, Text, Shadow, Icon, ImgIcon } from "components";

import { _goToCompanyProfile } from "routers/helper";
import { colors, sizes, strings } from "assets/constants";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";
import { useChmod } from "hooks";
import css from "styles";

export default function DrawerHeader() {
  const user = useRecoilValue(authAtom);
  const { chmod } = useChmod();

  return (
    <View>
      <TouchableOpacity
        activeOpacity={sizes.tapOpacity}
        onPress={
          user?.role === strings.ceo || user?.role === strings.super_admin
            ? _goToCompanyProfile
            : null
        }
      >
        <View style={styles.container}>
          <View style={styles.avatarContainer}>
            <View
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon
                size={40}
                name={"rhombus-split"}
                type="materialCommunity"
                color={colors.organization + "22"}
              />
            </View>
            <Img
              style={styles.avatar}
              source={{ uri: user?.company?.avatar }}
            />
          </View>

          <View style={{ ...styles.info }}>
            <Text style={{ top: 2 }} weight="extraBold">
              {user?.company?.name}
            </Text>
            <View style={{ bottom: 2 }}>
              <Text size={"sm"}>{user?.role}</Text>
            </View>
          </View>
        </View>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: sizes.drawerW - 2 * sizes.space,
    height: 65,
    alignSelf: "center",
    alignItems: "center",
    paddingHorizontal: sizes.space,
    flexDirection: "row-reverse",
    borderRadius: sizes.radius.md,
    backgroundColor: colors.white,
    marginTop: sizes.space,
    ...css.shadow(3),
  },

  avatarContainer: {
    width: 50,
    height: 50,
    overflow: "hidden",
    backgroundColor: colors.white,
    borderRadius: sizes.radius.lg,
    ...css.shadow(2),
  },

  avatar: { width: "100%", height: "100%" },

  info: { flex: 1, marginRight: sizes.space / 2 },
});
